import { MenuDivider, MenuItem, SubMenu } from '@szhsin/react-menu'
import { beautifulObjectIds } from '@stellar-globe/stellar-globe'
import { useAppDispatch, useAppSelector } from '../../store/hooks'
import { appearanceLayersSlice } from '../appearanceLayers/appearanceLayersSlice'
import { prettyPictureTitles } from './model'
import { prettyPicturesSlice } from './prettyPicturesSlice'

/** 「Layers」配下の画像表示・調整操作をまとめる。 */
export function PrettyPicturesMenu() {
  const visible = useAppSelector(state => state.appearanceLayers.nearbyGalaxiesAndNebulas.visible)
  const dialogsOpen = useAppSelector(state => state.prettyPictures.dialogsOpen)
  const dispatch = useAppDispatch()

  return (
    <SubMenu label="Nearby Galaxies and Nebulas">
      <MenuItem
        type="checkbox"
        checked={visible}
        onClick={() => dispatch(appearanceLayersSlice.actions.visibleToggled('nearbyGalaxiesAndNebulas'))}
      >
        Show
      </MenuItem>
      <MenuDivider />
      {beautifulObjectIds.map(which => (
        <MenuItem
          key={which}
          type="checkbox"
          checked={dialogsOpen[which]}
          onClick={() => dispatch(prettyPicturesSlice.actions.dialogToggled({ which }))}
        >
          {prettyPictureTitles[which]}
        </MenuItem>
      ))}
    </SubMenu>
  )
}
